module.exports = __webpack_public_path__ + "resources/img/img_logo_sw_kr.ff3c2a6540a715eb3e5f0759239eb66e.png";